module.exports = __webpack_public_path__ + "static/media/xaviers_logo.e08dc138.png";